import styled from "styled-components/macro";
import { textExtraSmallVar, textSmallVar, textSemiSmallVar } from "../../variables";
import { spacing, colorState, typography, radius } from "../../../Foundation";

export const filterScrollableHeight = "150px";
export const filterScrollableHeightlaptopL = "100px";
const tableFilterSectionMinWidth = "260";

interface Props {
    disabled?: boolean;
}

export const BoxTableModal = styled.div<Props>`
    position: absolute;
    left: 50%;
    top: calc(100% + ${spacing.spacing_8});
    transform: translateX(calc(-50% + var(--filter-shift-x, 0px)));
    box-shadow: 0 8px 36px ${colorState.surface.default["primary-inverse"]}50;
    background-color: ${colorState.background["secondary-bg"]};
    min-width: min(${tableFilterSectionMinWidth}px, calc(100vw - ${spacing.spacing_32}));
    max-width: calc(100vw - ${spacing.spacing_32});
    border-radius: ${radius.radius_8};
    border: 1px solid ${(props): string => props.theme.colors.primary.dark.color};
    box-sizing: border-box;
    cursor: default;
    z-index: 10;
    display: none;

    .filter {
        padding: ${spacing.spacing_16};
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: ${spacing.spacing_12} ${spacing.spacing_16};

        h1 {
            font-size: ${typography.size.tl};
            font-weight: ${typography.weight.semibold};
            line-height: ${spacing.spacing_28};
            color: ${colorState.text.primary};
            margin-bottom: 0;
        }

        .clear-all-btn {
            font-size: ${typography.size.ts};
            font-weight: ${typography.weight.medium};
            line-height: ${spacing.spacing_20};
            color: ${colorState.text.danger.primary};
            cursor: pointer;

            .disabled {
                cursor: not-allowed;
                opacity: 0.6;
            }
        }
    }

    .section-body {
        background-color: ${colorState.surface.default.primary};
        border-radius: ${radius.radius_8};
        margin: 0 ${spacing.spacing_8} ${spacing.spacing_8};

        .scrollable-content {
            padding: ${spacing.spacing_12};

            .search-filter-container {
                position: relative;
                margin-bottom: ${spacing.spacing_16};

                .search-icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    padding: ${spacing.spacing_6};
                }
            }

            h5 {
                font-size: ${textSemiSmallVar};
                font-weight: bold;
            }

            .asc-desc-btn-wrapper {
                justify-content: space-between;
                display: flex;
                margin-bottom: ${spacing.spacing_16};

                .asc-order {
                    margin-right: ${spacing.spacing_16};
                }

                .asc-order,
                .desc-order {
                    display: flex;
                    justify-content: center;
                    border: 1px solid #bababa;
                    border-radius: ${radius.radius_4};
                    padding: ${spacing.spacing_2} ${spacing.spacing_6};
                    cursor: pointer;
                    width: fit-content;
                    gap: ${spacing.spacing_16};

                    img {
                        padding-left: 0;
                    }

                    b {
                        color: #3f4650;
                        font-size: ${textExtraSmallVar};
                        font-weight: 400;
                    }
                }

                .asc-order:hover,
                .desc-order:hover {
                    background-color: #e6e6e6;
                }

                .button-active,
                .button-active:hover {
                    background-color: ${(props): string =>
                        props.theme.colors.primary.deep.backgroundColor};
                    border: 1px solid
                        ${(props): string => props.theme.colors.primary.deep.backgroundColor};

                    b {
                        color: white;
                    }
                }
            }
        }
    }

    .section-footer {
        display: flex;
        justify-content: space-between;
        padding: ${spacing.spacing_12};
        border-top: 1px solid ${colorState.border.default.tertiary};

        .clear {
            background-color: white;
            color: ${(props): string => props.theme.colors.primary.dark.backgroundColor};
            border: 1px solid ${(props): string => props.theme.colors.primary.dark.backgroundColor};
        }

        .apply {
            background-color: ${(props): string => props.theme.colors.primary.main.backgroundColor};
            color: white;
            border: 1px solid ${(props): string => props.theme.colors.primary.main.backgroundColor};
        }

        .clear,
        .apply {
            &:disabled {
                cursor: not-allowed;
                opacity: 0.5;
            }
        }
    }

    .container {
        display: block;
        position: relative;
        padding-left: ${spacing.spacing_36};
        margin-bottom: ${spacing.spacing_12};
        color: #45445c;
        cursor: pointer;
        font-size: ${textSmallVar};
        font-weight: 400;
        user-select: none;
    }

    .container p {
        margin: 0;
        padding: 0;
        max-width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 18px;
        width: 18px;
        background-color: white;
        border-radius: ${radius.radius_4};
        border: 1px solid #707070;
    }

    .container:hover input ~ .checkmark {
        border: 1px solid ${(props): string => props.theme.colors.primary.main.backgroundColor};
    }

    .container input:checked ~ .checkmark {
        background-color: ${(props): string => props.theme.colors.primary.main.backgroundColor};
        border: 2px solid ${(props): string => props.theme.colors.primary.main.backgroundColor};
    }

    .checkmark::after {
        content: "";
        position: absolute;
        display: none;
    }

    .container .checkmark::after {
        left: 4.5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
    }

    .container input:checked ~ .checkmark::after {
        display: block;
    }
`;

export const Scrollable = styled.div`
    overflow: auto;
    max-height: ${filterScrollableHeight};
`;
